 <template lang="pug">
//- overlay
.fixed.overlay.overflow-y-scroll.z-50.flex.py-20.transition.duration-700(@click.self="closePopup", :class="{'pointer-events-none opacity-0': !isVisible}")
  //- card
  .flex.flex-col.bg-indigo-50.px-6.relative.m-auto
    button.cursor-pointer.absolute.top-0.right-0.p-10(@click="closePopup")
      svg-x.w-16.h-16
    .flex.flex-col.text-center.px-24.pt-40
      h6.text-13.px-10(v-html="intro")
      form(@submit.prevent="submit").mt-110
        //- email input
        input.border-b.border-gray-700.min-w-full.text-center.bg-transp.py-8.mb-5.uppercase(type="email", placeholder="Enter your email adress here" v-model="email", required)
        //- status/error msg
        p.font-sans(:class="{'text-red': status === 'error'}") {{ msg || '&nbsp;' }}
        //- submit
        input.text-13.border.border-black.rounded-full.px-14.py-4.bg-transp.cursor-pointer.hover-bg-black.hover-text-white.mb-90.transition-all.duration-100.focus-bg-black.focus-text-white.mt-16(type="submit" value="SUBMIT")
    img(src='@/assets/ottolinger-logo-2020-blk100.png').w-160.mx-auto.mb-24
</template>

<script>
import { mapState } from 'vuex'
import SvgX from '@/components/icons/SVG-X'
export default {
  name: 'NewsletterPopup',
  components: { SvgX },
  data () {
    return {
      status: null,
      msg: null,
      email: '',
      isVisible: false,
      hasSubscribed: localStorage.getItem('subscribed')
    }
  },
  computed: {
    ...mapState({
      enabled: state => state.site && state.site.newsletter_popup_enabled,
      intro: state => state.site && state.site.newsletter_intro
    })
  },
  methods: {
    async submit () {
      this.status = null
      this.msg = null
      try {
        const resp = await this.$store.dispatch('subscribeToNewsletter', this.email)
        // messages...
        this.status = resp.status !== 200 ? 'error' : 'success'
        this.msg = resp.message === 'Success' ? 'Thank you for your subscription' : resp.message
        if (resp.status === 200) {
          localStorage.setItem('subscribed', true)
          setTimeout(() => this.closePopup(), 3000)
        }
      } catch (e) {
        // error
        this.status = 'error'
        this.msg = e.message || 'An error occured'
      }
    },
    closePopup () {
      this.isVisible = false
      sessionStorage.setItem('subscribe_hidden', true)
    },
    revealAfterScrollWithDelay (delay) {
      const isEnabled = this.enabled && !this.hasSubscribed && !sessionStorage.getItem('subscribe_hidden')
      if (isEnabled) {
        window.addEventListener('scroll', () => {
          setTimeout(() => {
            this.isVisible = true
          }, delay)
        }, { once: true })
      }
    }
  },
  mounted () {
    this.revealAfterScrollWithDelay(2000)
  },
  watch: {
    enabled () {
      this.revealAfterScrollWithDelay(2000)
    }
  }
}
</script>
